import defineMessages from "../../../common/helpers/defineMessages";

const messages: {[prop: string]: { id: string }} = defineMessages({
    title: {
        id: "articles.listing.title",
    },
    description: {
        id: "articles.listing.description",
    },
    subtitle1: {
        id: "articles.listing.1.title",
    },
    subtitle2: {
        id: "articles.listing.2.title",
    },
    subtitle3: {
        id: "articles.listing.3.title",
    },
    subtitle4: {
        id: "articles.listing.4.title",
    },
    subtitle5: {
        id: "articles.listing.5.title",
    },
    subtitle6: {
        id: "articles.listing.6.title",
    },
    description1: {
        id: "articles.listing.1.description",
    },
    description2: {
        id: "articles.listing.2.description",
    },
    description3: {
        id: "articles.listing.3.description",
    },
    description4: {
        id: "articles.listing.4.description",
    },
    description5: {
        id: "articles.listing.5.description",
    },
    description6: {
        id: "articles.listing.6.description",
    },
    firstCollection: {
        id: "pack.start",
    },
    firstTest: {
        id: "test.start",
    },
});

export default messages;
